import { NumberInput as NumberInputType } from '../../../../../../types/Survey/Element'
import { NumberInput as NumberInputAnswerType } from '../../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'

const NumberInput: React.FC<Props<NumberInputType, NumberInputAnswerType>> = ({ element, answerElement }) => {
  return (
    <div>
      <Core element={element} />
      <div className="mt-3">
        <div className="flex flex-col mt-3 max-h-60 overflow-x-hidden overflow-y-auto">
          <div className="font-bold">{`${answerElement.number} ${element.suffix}`}</div>
        </div>
      </div>
    </div>
  )
}

export default NumberInput
